/** 选项数据结构 */
export interface PickerOption {
  /** 选项显示文本 */
  text: string | number;
  /** 选项对应的值 */
  value: string | number;
  /** 子选项（用于级联选择） */
  children?: PickerOption[];
  /** 是否禁用 */
  disabled?: boolean;
  /** 自定义类名 */
  className?: string;
  /** 允许通过自定义字段名动态访问 */
  [key: string]: unknown;
}

/** 自定义字段名映射 */
export interface PickerFieldNames {
  text?: string;
  value?: string;
}

/** confirm / cancel 事件参数 */
export interface PickerEventParams {
  /** 所有列的选中值 */
  selectedValues: (string | number)[];
  /** 所有列的选中选项 */
  selectedOptions: PickerOption[];
  /** 所有列的选中索引 */
  selectedIndexes: number[];
}

/** change 事件参数（额外包含列索引） */
export interface PickerChangeEventParams extends PickerEventParams {
  /** 变化的列索引 */
  columnIndex: number;
}

/** PickerColumn change 事件参数 */
export interface PickerColumnChangeEventParams {
  /** 当前选中值 */
  value: string | number;
  /** 当前选中索引 */
  index: number;
  /** 当前选中选项 */
  option: PickerOption;
}

/** Picker 组件暴露的方法接口 */
export interface PickerExpose {
  open: () => void;
  close: () => void;
  confirm: () => void;
  getSelectedOptions: () => PickerOption[];
}

/** PickerColumn 组件暴露的方法接口 */
export interface PickerColumnExpose {
  scrollTo: (_index: number, _immediate?: boolean) => void;
  stopMomentum: () => void;
  getCurrentIndex: () => number;
}

/** 默认字段名配置 */
export const DEFAULT_FIELD_NAMES: Required<PickerFieldNames> = {
  text: 'text',
  value: 'value',
};
